import {
  SET_SEARCH_CLAIM_CCR,
  ADD_SELECTED_CLAIM_CCR,
  Remove_SELECTED_CLAIM_CCR,
  UPDATE_SELECTED_CLAIM_CCR,
  SET_VIEW_MODE,
  UPDATE_SEARCH_CLAIM_CCR,
  SET_SELECTED_CLAIM_CCR,
  CLEAR_CLAIM_CREATE_DATA,
  SET_CLAIMPROBLEM,
  SET_SEARCH_FROM_TOS,
  SET_CLAIM_CREATE_MODE,
  UPDATE_SEARCH_CCR_UNSELECTE,
  UPDATE_SEARCH_CLAIM_TOS_UNSELECT,
  UPDATE_SEARCH_CLAIM_TOS,
  SET_CLAIM_SELECTED_MATERIAL_CONFIRM,
  SET_CLAIM_SELECTED_MATERIAL,
  SET_CLAIM_SELECTED_MANUAL,
  REMOVE_CLAIM_SELECTED_MAUNAL,
  EDIT_CLAIM_SELECTED_MANUAL,
  ADD_CLAIM_SELECTED_MANUAL,
  SET_DRAFT_CLAIM_CREATE_CONFIRM,
} from "./actionType";

const draftCreateConfirmDefault = {
  Images: [],
  Files: [],
};

const init = {
  searchCCR: [],
  selectedCCR: [],
  mode: "search",
  claimProblem: [],
  searchTOS: [],
  createMode: "ccr",
  selectedMaterialConfirm: [],
  selecteMaterial: [],
  selectedManual: [],
  draftCreateConfirm: draftCreateConfirmDefault,
};

export default function reducer(state = init, action) {
  if (action.type === CLEAR_CLAIM_CREATE_DATA)
    return {
      ...init,
      createMode: state.createMode || init.createMode,
    };

  return {
    searchCCR: searchCCR(state.searchCCR, action),
    selectedCCR: selectedCCR(state.selectedCCR, action),
    mode: mode(state.mode, action),
    claimProblem: claimProblem(state.claimProblem, action),
    searchTOS: searchTOS(state.searchTOS, action),
    createMode: createMode(state.createMode, action),
    selectedMaterialConfirm: selectedMaterialConfirm(
      state.selectedMaterialConfirm,
      action
    ),
    selecteMaterial: selecteMaterial(state.selecteMaterial, action),
    selectedManual: selectedManual(state.selectedManual, action),
    draftCreateConfirm: draftCreateConfirm(state.draftCreateConfirm, action),
  };
}

function draftCreateConfirm(state = draftCreateConfirmDefault, action) {
  switch (action.type) {
    case SET_DRAFT_CLAIM_CREATE_CONFIRM:
      return {
        ...action.payload,
      };
    default:
      return state;
  }
}

function selectedManual(state = [], action) {
  switch (action.type) {
    case SET_CLAIM_SELECTED_MANUAL:
      return [...action.payload];
    case REMOVE_CLAIM_SELECTED_MAUNAL:
      return [
        ...state.slice(0, action.index),
        ...state.slice(action.index + 1),
      ];
    case EDIT_CLAIM_SELECTED_MANUAL:
      return [
        ...state.slice(0, action.index),
        {
          ...action.payload,
        },
        ...state.slice(action.index + 1),
      ];
    case ADD_CLAIM_SELECTED_MANUAL:
      return [
        ...state,
        {
          ...action.payload,
        },
      ];
    default:
      return state;
  }
}

function selecteMaterial(state = [], action) {
  switch (action.type) {
    case SET_CLAIM_SELECTED_MATERIAL:
      return [...action.payload];
    default:
      return state;
  }
}

function selectedMaterialConfirm(state = [], action) {
  switch (action.type) {
    case SET_CLAIM_SELECTED_MATERIAL_CONFIRM:
      return [...action.payload];
    default:
      return state;
  }
}

function createMode(state = "ccr", action) {
  switch (action.type) {
    case SET_CLAIM_CREATE_MODE: {
      return action.payload;
    }
    default:
      return state;
  }
}

function searchTOS(state = [], action) {
  switch (action.type) {
    case SET_SEARCH_FROM_TOS: {
      return [...action.payload];
    }
    case UPDATE_SEARCH_CLAIM_TOS_UNSELECT: {
      return state.map((m) => {
        m.Selected = false;
        return m;
      });
    }
    case UPDATE_SEARCH_CLAIM_TOS: {
      return state.map((m, idx) => {
        if (idx === Number(action.index))
          return {
            ...action.payload,
          };
        else return m;
      });
    }
    default:
      return state;
  }
}

function claimProblem(state = [], action) {
  switch (action.type) {
    case SET_CLAIMPROBLEM: {
      return [...action.payload];
    }
    default:
      return state;
  }
}

function mode(state = "search", action) {
  switch (action.type) {
    case SET_VIEW_MODE: {
      return action.payload;
    }
    default:
      return state;
  }
}

function searchCCR(state = [], action) {
  switch (action.type) {
    case SET_SEARCH_CLAIM_CCR: {
      return [...action.payload];
    }
    case UPDATE_SEARCH_CLAIM_CCR: {
      return state.map((m, idx) => {
        if (idx === action.index)
          return {
            ...m,
            ...action.payload,
          };
        return m;
      });
    }
    case UPDATE_SEARCH_CCR_UNSELECTE: {
      return state.map((m) => {
        m.Selected = false;
        return m;
      });
    }
    default:
      return state;
  }
}

function selectedCCR(state = [], action) {
  switch (action.type) {
    case SET_SELECTED_CLAIM_CCR: {
      return [...action.payload];
    }
    case ADD_SELECTED_CLAIM_CCR: {
      if (!action.claimType || !action.claimType === "ccr") {
        if (
          state.find(
            (f) =>
              f.MaterialNo === action.payload.MaterialNo &&
              f.CCRNo === action.payload.CCRNo &&
              f.LotNo === action.payload.LotNo &&
              f.BillingNo === action.payload.BillingNo
          )
        ) {
          return state;
        }
      } else {
        if (state.find((f) => f.TosItemId === action.payload.TosItemId)) {
          return state;
        }
      }

      let newArray = state.slice();
      newArray.push(action.payload);
      return newArray;
    }
    case Remove_SELECTED_CLAIM_CCR: {
      return state.filter((m, idx) => idx !== action.index);
    }
    case UPDATE_SELECTED_CLAIM_CCR: {
      return state.map((m, idx) => {
        if (idx === action.index)
          return {
            ...m,
            ...action.payload,
          };
        return m;
      });
    }
    default:
      return state;
  }
}
